<style scoped="scoped" lang="scss"></style>

<template>
  <div>
    <!-- table表格 -->
    <!-- 表格 -->
    <div class="table">
      <el-form size="mini" :inline="true" :model="conditions" class="demo-form-inline">
        <el-form-item :label="$t('shengchangongdanhao')">
          <el-input v-model="conditions.no"></el-input>
        </el-form-item>
        <el-form-item :label="$t('ERPgongdanhao')">
          <el-input v-model="conditions.erpNo"></el-input>
        </el-form-item>
        <el-form-item :label="$t('gongdanzhuangtai')">
          <yi_dictionary_select :max="8" multiple :type="'PRODUCTION_WO_STATUS'" :ids.sync="conditions.statusList"> </yi_dictionary_select>
        </el-form-item>

        <el-form-item>
          <el-button @click="getData" type="primary" plain="plain">
            {{ $t('sousuo') }}
          </el-button>
          <el-button @click="resetCondition">{{ $t('chongzhi') }} </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
      <el-table ref="table" stripe size="mini" border style="width: 100%;overflow-y: auto;" :row-key="val => val.id" v-loading="isLoading" :data="currentTableData.slice((currentPage - 1) * pageSize, currentPage * pageSize)" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px', 'font-size': '14px' }" @header-dragend="headerDragend" @selection-change="val => (selectedRow = val)" @row-click="handleRowClick">
        <el-table-column :reserve-selection="true" type="selection" width="55"></el-table-column>
        <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :label="$t(item.label)" :sortable="item.sortable" :width="item.width" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="item.prop === 'status'">
              <el-tag v-if="item.type == 'tag'" effect="light" size="small" :style="{
        color: item.tags[utils.getObjValueByLevelString(scope.row, item.prop) + ''].color,
        'background-color': item.tags[utils.getObjValueByLevelString(scope.row, item.prop) + ''].color + '10',
        border: 'none'
      }" :color="item.tags[utils.getObjValueByLevelString(scope.row, item.prop) + ''].color">
                {{ item.tags[utils.getObjValueByLevelString(scope.row, item.prop) + ''].text }}
              </el-tag>
            </template>
            <template v-if="item.prop === 'reportQuantity'">
              {{ scope.row.finishGoodQuantity + scope.row.finishBadQuantity }}
            </template>
            <template v-if="item.prop === 'equipment.name'">
              {{ scope.row.equipment.name }}
            </template>
            <template v-if="item.prop === 'mould.no'">
              {{ scope.row.mould.no }}
            </template>
            <template v-if="item.prop === 'material.code'">
              {{ scope.row.material.code }}
            </template>
            <template v-if="item.prop === 'material.name'">
              {{ scope.row.material.name }}
            </template>
            <template v-else-if="item.prop !== 'status'">
              {{ scope.row[item.prop] }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right;margin-top: 8px">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" @prev-click="handleCurrentChange" @next-click="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next" :total="currentTableData.length"> </el-pagination>
      </div>
    </div>
    <div slot="footer" class="dialog-footer" style="text-align: right; margin: 18px">
      <el-button size="mini" @click="clearSelectedRow">
        {{ $t('quxiao') }}
      </el-button>
      <el-button :loading="saveLoading" size="mini" @click="bindWo" type="primary" v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '首末检验-绑定生产工单' } }">
        {{ $t('baocun') }}
      </el-button>
    </div>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'web_quality_management_record_first_work_order',
  data() {
    return {
      isLoading: false, // 控制加载状态的变量
      saveLoading: false,
      conditions: {},
      selectedRow: [],
      planIdList: '',
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示的行数
      dataList: [],
      equipmentPieList: [],
      tableData: [],
      reasonPieList: [],
      currentTableData: [],
      tableColumn: [
        {
          label: 'shengchangongdanhao',
          prop: 'no',
          width: 180
        },
        {
          label: 'ERPgongdanhao',
          prop: 'erpNo',
          width: 130
        },
        {
          label: 'gongdanzhuangtai',
          type: 'tag',
          prop: 'status',
          width: 130,
          tags: {
            1: {
              color: '#419FFF',
              text: this.$t('xinjian')
            },
            2: {
              color: '#419FFF',
              text: this.$t('fafang')
            },
            3: {
              color: '#67C23A',
              text: this.$t('shengchanzhong')
            },
            4: {
              color: '#F56C6C',
              text: this.$t('zanting')
            },
            5: {
              color: '#67C23A',
              text: this.$t('shougongxuwangong')
            },
            6: {
              color: '#67C23A',
              text: this.$t('wangong')
            },
            7: {
              color: '#909399',
              text: this.$t('guanbi')
            },
            8: {
              color: '#E6A23C',
              text: this.$t('yidiaobo')
            }
          }
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipment.name',
          width: 130
        },
        {
          label: 'mujubianhao',
          prop: 'mould.no',
          width: 130
        },
        {
          label: 'chanpinbianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'material.name',
          width: 130
        },
        {
          label: 'jihuashuliang',
          prop: 'planQuantity'
        },
        {
          label: 'baogongshuliang',
          prop: 'reportQuantity',
          width: 130
        },
        {
          label: 'yibaogongliangpinshu',
          prop: 'finishGoodQuantity',
          width: 130
        },

        {
          label: 'yibaogongbuliangpinshu',
          prop: 'finishBadQuantity',
          width: 130
        },
        {
          label: 'shengyushengchanshuliang',
          prop: 'leftProductionQuantity',
          width: 130
        }
      ]
    };
  },
  computed: {
    // 计算表格容器的高度，不超过父容器的剩余可用高度
  },
  created() {
    setTimeout(() => {
      this.getData();
      this.utils.event_hub.$on('INSPECTION_RECORD_BIND_WO_WORK_ORDER_REFRESH', () => {
        this.getData();
      });
    }, 300);
  },
  destroyed() {
    this.utils.event_hub.$off('INSPECTION_RECORD_BIND_WO_REFRESH');
    clearInterval(this.timmer);
    clearInterval(this.interval);
  },

  methods: {
    clearSelectedRow() {
      this.selectedRow = [];
      this.$refs.table.clearSelection();
      this.utils.event_hub.$emit('INSPECTION_RECORD_BIND_WO_WORK_ORDER_CLOSE'); // 触发自定义事件
    },
    handleRowClick(row, column, event) {
      this.$refs.table.toggleRowSelection(row);
    },
    bindWo() {
      if (!this.selectedRow || this.selectedRow.length === 0) {
        // 如果 selectedRow 为空，弹出提示
        this.utils.errorMessage(this.$t('qingzhishaoxuanzeyihangshujv'));
        return; // 提前返回，不执行请求
      }
      // 在加载数据之前将 saveLoading 设置为 true
      this.saveLoading = true;
      this.http
        .post('/web/inspection/record/bind/wo/bind', {
          inspectionRecordId: this.$attrs.detailsItem.id,
          main: false,
          woIds: this.selectedRow.map(item => item.id)
        })
        .then(res => {
          // 加载完成后将 saveLoading 设置为 false
          this.saveLoading = false;
          this.utils.successMessage(this.$t(res.msg));
          this.getData();
          this.selectedRow = [];
          this.$refs.table.clearSelection();
          this.utils.event_hub.$emit('INSPECTION_RECORD_BIND_WO_REFRESH');
        })
        .catch(msg => {
          this.utils.errorMessage(msg);
          this.saveLoading = false;
        });
    },

    handleSelectionChange(selection) {
      this.currentPage = val;
    },
    // 页面切换方法
    handleCurrentChange(val) {
      this.currentPage = val;
    },
    //条数切换
    handleSizeChange(value) {
      this.pageSize = value;
    },
    headerDragend(newWidth, oldWidth, column, event) {
      const name = 'web_quality_management_record_first_work_order';
      let colwidths = {};
      if (window.localStorage.getItem('colwidth_' + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem('colwidth_' + name));
        } catch (e) {
          window.localStorage.removeItem('colwidth_' + name);
        }
      }
      if (column.label == '' || column.label == null) {
        return;
      }
      colwidths[column.label] = column.width;
      window.localStorage.setItem('colwidth_' + name, JSON.stringify(colwidths));
    },
    resetCondition() {
      this.conditions = {};
      this.getData();
    },
    getData() {
      this.selectedRow = [];
      this.$refs.table.clearSelection();
      // 在加载数据之前将 isLoading 设置为 true
      this.isLoading = true;
      this.currentPage = 1;
      let requestParam = {
        ...this.conditions,
        pageNum: 1,
        pageSize: 1000,
        //status: '3',
        equipmentId: this.$attrs.detailsItem.equipmentId,
        materialId: this.$attrs.detailsItem.materialId,
        orderBy: 'createTime desc'
      };
      return this.http
        .get('/web/production/wo/pageUnbindForQuality?' + this.qs.stringify(requestParam))
        .then(response => {
          // 加载完成后将 isLoading 设置为 false
          this.isLoading = false;
          const data = response.data;
          // this.dataList = data
          // 表格
          this.totalTime = data.extend.totalTime || 0;
          this.tableData = data.rows;
          this.currentTableData = data.rows;
        })
        .catch(error => {
          this.$message.error(error);
          this.isLoading = false;
        });
    },
    // beforeGet(params) {
    //   params['orderBy'] = 'createTime desc'
    //   params['woStatusList'] = 3
    //   return params
    // },
    selectionChange(items) {
      this.planIdList = items.map(item => {
        return item.id;
      });
      this.planId = items
        .map(item => {
          return item.no;
        })
        .join(',');
    }
  }
};
</script>
